import { BaseViewStore, BaasicDropdownStore } from "core/stores";
import { ModalParams } from 'core/models';
import { PatientService, LocalPatientService } from "application/patient/services";
import { FacilityOrderTemplateService, FacilityOrderTemplateItemService } from "application/facility-order/services";
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { action, observable } from "mobx";
import _ from 'lodash';

class FacilityOrderTemplateNewFlowInsuranceEditViewStore extends BaseViewStore {
	@observable accessor items;
	@observable accessor facilityOrderPatient;
	@observable accessor inactiveOptionStorId = "";
	@observable accessor isOrderVisible = false;
	@observable accessor patient = null;
	@observable accessor disabledPatient = false;

	inactiveOptions = [{ id: "15", name: "Hospital" }, { id: "17", name: "Discharged" }, { id: "18", name: "Expired" }, { id: "0", name: "Active" }];

	constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;

        this.id = componentsProps.id;
        this.patient = componentsProps.item[0].patient;
        this.facilityOrder = componentsProps.facilityOrder;
        this.lookups = componentsProps.lookups;
        this.selectedStatusAbrv = componentsProps.selectedStatusAbrv;
        this.isSelectedItemCategory = componentsProps.selectedItemCategories && componentsProps.selectedItemCategories.length > 0;
        this.checkIsInsuranceReviewCompleted = componentsProps.checkIsInsuranceReviewCompleted;
        this.fetchTemplatesByPatientId = componentsProps.fetchTemplatesByPatientId;
        this.isMasterPatient = this.facilityOrder.facility.masterPatientId == this.patient.patientKey;

        if (this.selectedStatusAbrv === "change") {
			this.showDropdownTableInactiveOptions = true;
			this.showTemplateNote = true;
		}
		else if (this.selectedStatusAbrv === "no-change") {
			this.showDropdownTableInactiveOptions = true;
		}
		else if (this.selectedStatusAbrv === "discharge") {
			this.isDisabledInactiveOption = true;
			this.isDisabledInactiveOptionDropdown = componentsProps.item.some(i => i.newFlowStatus.abrv === "discharge" && i.newFlowStatusUpdatedByUserId !== null) && !componentsProps.item.some(i => i.newFlowStatus.abrv === "discharge" && i.newFlowStatusUpdatedByUserId === this.rootStore.userStore.user.id);
		}

        this.inactiveOptionStore = new BaasicDropdownStore({
			multi: false, filterable: false, disabled: this.isDisabledInactiveOptionDropdown
		}, {
			fetchFunc: () => {
				return this.inactiveOptions;
			},
		});

        this.localPatientService = new LocalPatientService(rootStore.application.baasic.apiClient);
        this.patientService = new PatientService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);

        this.facilityOrderTemplateNewFlowInsuranceProductModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowActivatePatientModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceNoteModal = new ModalParams({ onClose: () => { this.initializePatient() } });
        this.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceEditModal = new ModalParams({});

        this.fetch([
			this.initialize(componentsProps.item)
		]);
    }

	@action.bound
	async initialize(items) {
		await this.initializePatient();
		this.items = items;
		this.isOrderVisible = this.selectedStatusAbrv === "in-progress" && (!this.isNewPatient) && this.items && this.items.some(i => !i.templateId) && this.facilityOrderPatient && this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible" && this.patient.primaryInsurance !== "Medicare";
		this.getPatientStatusButtonClassName();
	}

	@action.bound
	async initializePatient() {
		var response = (await this.facilityOrderPatientService.find({ facilityOrderId: this.facilityOrder.id, patientId: this.patient.id, embed: 'EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus' })).data.item;
		this.facilityOrderPatient = response && response[0];
		this.isNewPatient = this.facilityOrderPatient && this.facilityOrderPatient.isNewPatient;
	}

	@action.bound
	async fetchPatientTemplates() {
        this.items = await this.fetchTemplatesByPatientId();
    }

	@action.bound
	async fetchPatient() {
		if (this.patient) {
			let response = await this.localPatientService.get(this.patient.id);
			this.patient = response.data;
		}
	}

	@action.bound
	getPatientStatusButtonClassName(inactiveOptionId = null) {
		this.inactiveOptionStorId = "";

		this.inactiveOptions.filter(i => !inactiveOptionId || i.id === inactiveOptionId).forEach((item) => {
			if (this.selectedStatusAbrv === "discharge") {
				if (item.name === "Hospital" && this.facilityOrderPatient.activeStatus === 'Hospital') {
					this.inactiveOptionStorId = "15";
				}
				else if (item.name === "Discharged" && this.facilityOrderPatient.activeStatus === 'Discharged') {
					this.inactiveOptionStorId = "17";
				}
				else if (item.name === "Expired" && this.facilityOrderPatient.activeStatus === 'Expired') {
					this.inactiveOptionStorId = "18";
				}
				else if (item.name === "Active" && this.facilityOrderPatient.activeStatus !== 'Hospital' && this.facilityOrderPatient.activeStatus !== 'Discharged' && this.facilityOrderPatient.activeStatus !== 'Expired') {
					this.inactiveOptionStorId = "0";
				}
			}
			else if (item.name === "Active") {
				this.inactiveOptionStorId = "0";
			}
		});
	}

	@action.bound
	openFacilityOrderTemplateNewFlowInsuranceProductModal(facilityOrderTemplate) {
		this.facilityOrderTemplateNewFlowInsuranceProductModal.open({
			facilityOrderTemplate: facilityOrderTemplate
		});
	}

	@action.bound
	changeOrderVisibility() {
		this.isOrderVisible = !this.isOrderVisible;
	}

	@action.bound
	async openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptionId, setInactiveReasonAndStatuses = false) {
		this.disabledPatient = true;
		if (inactiveOptionId === "0") {
			if (this.selectedStatusAbrv === "discharge") {
				this.facilityOrderTemplateItemNewFlowActivatePatientModal.open({
					patient: this.patient,
					setInactiveOption: () => this.setInactiveOption("in-progress", inactiveOptionId, setInactiveReasonAndStatuses),
					setPatientStatus: async () => await this.setPatientStatus("Active")
				});
			}
			else if (this.selectedStatusAbrv === "in-progress") {
				await this.setPatientStatus("Active")
				await this.setInactiveOption("in-progress", inactiveOptionId, setInactiveReasonAndStatuses);
			}
		}
		else {
			await this.setPatientStatus(inactiveOptionId === "15" ? "Hospital" : inactiveOptionId === "17" ? "Discharged" : inactiveOptionId === "18" ? "Expired" : "Active");
			await this.setInactiveOption("discharge", inactiveOptionId, setInactiveReasonAndStatuses);
		}
		this.disabledPatient = false;
	}
	@action.bound
	async openFacilityOrderPatientNewFlowInsuranceNoteModal(newFlowStatusAbrv = null) {
		this.facilityOrderPatientNewFlowInsuranceNoteModal.open({
			facilityOrderPatient: this.facilityOrderPatient,
			facilityOrderId: this.facilityOrder.id,
			patient: this.patient,
			facilityOrderTemplates: this.items,
			setNewFlowStatus: () => newFlowStatusAbrv ? this.setNewFlowStatus(newFlowStatusAbrv, undefined, true, true) : this.initializePatient(),
			// Reload the local patient (insurance) and the facility order patient so the backend-recomputed
			// "No OON Benefits" eligibility status note is displayed after the primary active insurance changes.
			refreshInsuranceData: async () => {
				await this.fetchPatient();
				await this.initializePatient();
			},
			fetchPatientTemplates: async () => await this.fetchPatientTemplates(),
			// setNewFlowStatusOnPolicyUpdate: (this.facilityOrderPatient && this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible") ? async () => await this.setNewFlowStatus("change", null, false, null, "insurance") : null
		});
	}

	@action.bound
	async openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal() {
		this.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal.open({
			patient: this.patient,
			facilityOrderTemplates: this.items,
			facilityOrderPatient: this.facilityOrderPatient
		});
	}

	@action.bound
	async setInactiveOption(newFlowStatusAbrv, inactiveOptionId, setInactiveReasonAndStatuses = false) {
		this.disabledPatient = true;
		_.each(this.items, item => {
			item.inactiveReasonId = inactiveOptionId;
			item.inactiveReason = this.inactiveOptions.find(i => i.id === inactiveOptionId).name;
		});

		this.getPatientStatusButtonClassName(inactiveOptionId);
		await this.setNewFlowStatus(newFlowStatusAbrv, inactiveOptionId, setInactiveReasonAndStatuses);
		this.disabledPatient = false;
	}

	@action.bound
	async setNewFlowStatus(
        statusAbrv,
        inactiveOptionId,
        setInactiveReasonAndStatuses = false,
        fetchPatientTemplates = false
    ) {
		try {
			const status = this.lookups.newFlowStatus.find(s => s.abrv === statusAbrv);
			let updateItems = this.items;
			if (this.isSelectedItemCategory && statusAbrv === "discharge") {
				const selectedStatus = this.lookups.newFlowStatus.find(s => s.abrv === this.selectedStatusAbrv);
				updateItems = (await this.facilityOrderTemplateService.find({
					facilityOrderId: this.facilityOrderId,
					patientId: this.id,
					newFlowStatusId: selectedStatus.id,
				})).data.item;
			}

			await this.facilityOrderTemplateService.batchUpdate(_.map(updateItems, item => {
				return {
					id: item.id,
					inactiveReasonId: inactiveOptionId ? inactiveOptionId : item.inactiveReasonId,
					newFlowStatusId: statusAbrv === "discharge" || statusAbrv === "in-progress" ? status.id : item.newFlowStatusId,
					newFlowInsuranceStatusId: status.id,
					portalNote: item.portalNote,
					newFlowStatusUpdatedByUserId: item.newFlowStatusUpdatedByUserId,
					setInitialEligibility: this.selectedStatusAbrv === "discharge" && inactiveOptionId === "0",
					newFlowUSIntakeStatusId: statusAbrv === "discharge" || statusAbrv === "in-progress" ? status.id : item.newFlowStatusId,
					setInactiveReason: setInactiveReasonAndStatuses,
					isTemplateStatus: false,
					setStatuses: false,
					setInsuranceStatus: false
				};
			}));

			if (statusAbrv !== this.selectedStatusAbrv) {
				this.items = null;
			}

			if (!this.items && this.selectedStatusAbrv === 'in-progress') {
				await this.checkIsInsuranceReviewCompleted();
			}

			if(fetchPatientTemplates){
				await this.fetchPatientTemplates();
			}
		}
		catch (err) {
			this.rootStore.notificationStore.error(
				"An unexpected error occurred while trying to update the template.",
				err
			);
		}
	}

	@action.bound
	getSelectedInactiveOption() {
		if (this.selectedStatusAbrv === "change") {
			return "reload--warning";
		}
		else if (this.selectedStatusAbrv === "no-change") {
			return "success";
		}
		return "";
	}

	@action.bound
	async setSelectedInactiveOption(abrv) {
		if (abrv !== this.selectedStatusAbrv) {
			if (abrv == "no-change") {
				await this.setNewFlowStatus(abrv);
			} else if (abrv == "change") {
				await this.openFacilityOrderPatientNewFlowInsuranceNoteModal(abrv);
			}
		}
	}

	@action.bound
	async openInsuranceInformation() {
		window.open(`${this.rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl}Patient/frmPatientInsuranceRO.aspx?PatientKey=${this.patient.patientKey}&Edit=0`)
	}
	@action.bound
	async setPriorAuthNeeded(facilityOrderTemplate) {
		facilityOrderTemplate.isPriorAuthNeeded = !facilityOrderTemplate.isPriorAuthNeeded;
		await this.facilityOrderTemplateService.updatePriorAuthNeeded({ id: facilityOrderTemplate.id, isPriorAuthNeeded: facilityOrderTemplate.isPriorAuthNeeded });
	}

	@action.bound
	async openFacilityOrderPatientNewFlowInsuranceEditModal() {
        this.facilityOrderPatientNewFlowInsuranceEditModal.open({
            patient: this.patient,
			// Reload the local patient (insurance) and the facility order patient so the backend-recomputed
			// "No OON Benefits" eligibility status note is displayed after the primary active insurance changes.
			refreshInsuranceData: async () => {
				await this.fetchPatient();
				await this.initializePatient();
			},
			disableEdit: true,
			facilityOrderPatient: this.facilityOrderPatient,
            facilityOrderTemplates: this.items
        });
    }

	@action.bound
	async setPatientStatus(status) {
		this.facilityOrderPatient.activeStatus = status;
		await this.facilityOrderPatientService.update(this.facilityOrderPatient);
	}
}

export default FacilityOrderTemplateNewFlowInsuranceEditViewStore;
